import React, { FC, useState, useEffect } from 'react';
import { Switch, Route, useLocation, useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import Favicon from 'react-favicon';
import { getHeadData } from '../stores/reducers/userData';
import routes from '../config/routes';
import Layout from './Layout/Layout';
import Page404 from './Page404';
import { DataDto, getAllSections, internalizationState } from '../stores/reducers/sections';
import Section from './Section';
import ExhibitionPage from './Pages/Exhibition/ExhibitionPage';
import QuestionsPage from './Pages/Questions/QuestionsPage';
import DemoZone from './Pages/DemoZone/DemoZone';
import DemoZoneMain from './Pages/DemoZone/DemoZoneMain';
import ExhibitionOfSponsors from './Pages/ExhibitionOfSponsors/ExhibitionOfSponsors';
import SponsorPage from './Pages/SponsorPage/SponsorPage';
import localeFieldResolver from '../helpers/locale-field-finder';
import DefaultPage from './DefaultPage';

const RenderSections: FC<{ sections?: DataDto[] }> = ({ sections }) => {
  const { id }: { id: string } = useParams();
  return <>{sections && sections.map((section: DataDto) => <Section key={section.id} data={section} newsId={id} />)}</>;
};

const Routes: FC<{isEventKeyCorrect: boolean;}> = ({isEventKeyCorrect}) => {
  const location = useLocation();
  const history = useHistory();
  const [searchParams, setSearchParams] = useState<string>();
  const headData: any = useSelector(getHeadData);
  const { activeLangState } = useSelector(internalizationState);
  const sections = useSelector(getAllSections);

  const meta = {
    title: localeFieldResolver(headData, 'title', activeLangState),
    description: localeFieldResolver(headData, 'description', activeLangState),
    meta: {
      name: {
        keywords: 'react,stream,document,html,tags',
      },
    },
  };

  const [ isHeaderTransparent, setHeaderTransparent ] = useState<boolean>(false)
  const routesForTransparentHeader: Array<String> = [routes.EXHIBITION, routes.QUESTIONS, routes.DEMOZONE, routes.DEMOZONE_INFO, routes.EXHIBITION_OF_SPONSORS]
  // const isTransparent: boolean = !routesForTransparentHeader.includes(location.pathname)
  useEffect(() => {
    let isHeaderMenuColored: boolean = true
    routesForTransparentHeader.forEach((routerPath: any): any => {
      if (location.pathname.indexOf(routerPath) !== -1 || location.pathname === routes.HOME) {
        isHeaderMenuColored = false
      }
    })

    if (!location.search && searchParams) {
      history.replace(location.pathname + searchParams);
      window.location.search = searchParams;
    }

    setHeaderTransparent(isHeaderMenuColored)
  }, [location.pathname, routesForTransparentHeader])

  useEffect(() => {
    if (location.search && !searchParams) {
      setSearchParams(location.search);
    }
  }, [location.search]);

  return (
    <>
      {headData && headData.favicon && <Favicon url={headData.favicon} />}
      <DocumentMeta {...meta}>
        {isEventKeyCorrect ?
          <Layout isHeaderSticky={isHeaderTransparent}>
            <Switch>
              <Route
                exact
                path={routes.HOME}
                render={() => <RenderSections sections={sections.filter((section) => section.page === 'HomePage')} />}
              />
              <Route
                exact
                path={routes.REGISTER}
                render={() => <RenderSections sections={sections.filter((section) => section.page === 'RegisterPage')} />}
              />
              <Route
                path={routes.LIVE}
                render={() => <RenderSections sections={sections.filter((section) => section.page === 'LivePage')} />}
              />
              <Route
                path={routes.SPEAKERS}
                render={() => <RenderSections sections={sections.filter((section) => section.page === 'SpeakersPage')} />}
              />
              <Route
                path={`${routes.STATIC}/:id`}
                render={() => <RenderSections sections={sections.filter((section) => section.page === 'StaticPage')} />}
              />
              <Route
                path={routes.EXHIBITION}
                render={() => <ExhibitionPage />}
              />
              <Route
                path={routes.QUESTIONS}
                render={() => <QuestionsPage />}
              />
              <Route
                exact
                path={routes.DEMOZONE}                
                render={(props) => {
                  const code: any = new URLSearchParams(props.location.search).get('code')
                  return <DemoZoneMain zoneCode={code} />
                }}
              />
              <Route
                exact
                path={routes.DEMOZONE_INFO}
                render={(props) => {
                  const code: any = new URLSearchParams(props.location.search).get('code')
                  return <DemoZone zoneCode={code} />
                }}
              />
              <Route
                path={routes.EXHIBITION_OF_SPONSORS}
                render={() => <ExhibitionOfSponsors />}
              />
              <Route
                path={routes.SPONSOR_PAGE}
                render={(props) => {
                  const name: any = new URLSearchParams(props.location.search).get('name')
                  return <SponsorPage sponsorName={name} />
                }}
              />
              <Route component={Page404} />
            </Switch>
          </Layout>
          :
          <Route
            path={routes.HOME}
            render={() => <DefaultPage />}
          />
        }        
      </DocumentMeta>
    </>
  );
};

export default Routes;
